import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=08874c9e&scoped=true"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"
import style0 from "./Channels.vue?vue&type=style&index=0&id=08874c9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08874c9e",
  null
  
)

export default component.exports